// src/pages/Metodologia.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Metodologia.css";

const LANGUAGE_STORAGE_KEY = "zedro_academy_language";
const LANGUAGE_CHANGE_EVENT = "zedro:languagechange";

const copy = {
  es: {
    heroTitle:
      "Una metodología para convertir comprensión en decisiones, acciones y evidencia.",
    heroSubtitle:
      "Cada recorrido de ZEDRO Academy combina formación, reflexión, micro-misiones y registro para ayudarte a comprender, ordenar, practicar y sostener lo aprendido en la vida diaria.",
    viewMembership: "Comienza tu prueba gratuita",
    seeHowItWorks: "Ver cómo funciona",
    showcaseAria: "Vista previa de la experiencia ZEDRO",
    altMain: "Vista de los sistemas de 28 días dentro de ZEDRO Academy",
    altDay: "Vista de un día de formación dentro de ZEDRO Academy",
    altJournal: "Vista de la Bitácora ZEDRO",
    altMission: "Recorrido de una micro-misión diaria dentro de ZEDRO Academy",
    altConexion: "Vista de la experiencia guiada de Conexión ZEDRO",

    problemLabel: "La necesidad que atendemos",
    problemTitle: "Entre comprender y avanzar suele faltar una estructura.",
    problemLead:
      "Muchas personas reúnen información, ideas e inspiración, pero necesitan un proceso que les ayude a convertirlas en decisiones, acciones y aprendizajes sostenibles.",
    problem1Title: "La información no organiza por sí sola.",
    problem1Text:
      "Puedes conocer principios valiosos y todavía necesitar claridad para relacionarlos con tus prioridades, decisiones y vida cotidiana.",
    problem2Title: "La intención necesita un proceso.",
    problem2Text:
      "Una estructura clara ayuda a pasar de querer avanzar a definir qué hacer, ponerlo en práctica y revisar lo aprendido.",
    problem3Title: "ZEDRO convierte formación en recorrido.",
    problem3Text:
      "La metodología conecta comprensión, reflexión, acción y registro dentro de una ruta progresiva y coherente.",

    methodLabel: "El método ZEDRO Academy",
    methodTitle: "Un ciclo claro para comprender, ordenar, practicar y sostener.",
    methodLead:
      "Cada recorrido trabaja un área concreta mediante una secuencia que une contenido, reflexión, práctica diaria y evidencia del proceso.",
    flowAria: "Ciclo de formación ZEDRO",
    step1Title: "Comprender",
    step1Text:
      "Recibes contenido claro y preguntas que te ayudan a examinar un área concreta.",
    step2Title: "Ordenar",
    step2Text:
      "Relacionas lo aprendido con tus pensamientos, prioridades y decisiones.",
    step3Title: "Practicar",
    step3Text:
      "Lo conviertes en acciones concretas mediante micro-misiones y aplicación diaria.",
    step4Title: "Sostener",
    step4Text:
      "Registras evidencia, revisas lo aprendido y desarrollas continuidad con responsabilidad.",
    methodStatementSmall: "No es consumo pasivo.",
    methodStatementStrong:
      "Es formación aplicada con estructura, práctica y continuidad.",

    insideLabel: "Disponible actualmente",
    insideTitle:
      "Así funciona la experiencia que hoy encuentras en ZEDRO Academy.",
    insideLead:
      "La membresía ofrece actualmente sistemas de 28 días, jornadas guiadas, micro-misiones, Bitácora personal y Conexión para llevar lo aprendido a decisiones y prácticas concretas.",
    systemKicker: "01 · Sistemas",
    systemTitle: "Sistemas de 28 días con ruta clara.",
    systemText:
      "Cada sistema trabaja un área concreta durante 28 días, con progreso, continuidad y una estructura que ayuda a avanzar con dirección.",
    dayKicker: "02 · Día ZEDRO Academy",
    dayTitle: "Formación diaria paso a paso.",
    dayText:
      "Cada día organiza contenido, reflexión, acción, aplicación y cierre dentro de una secuencia clara.",
    missionKicker: "03 · Micro-misión",
    missionTitle: "Acciones pequeñas que dejan evidencia del proceso.",
    missionText:
      "La micro-misión convierte lo aprendido en una acción concreta y guarda evidencia del proceso en Bitácora ZEDRO.",
    journalKicker: "04 · Bitácora",
    journalTitle: "Decisiones, acciones y aprendizajes en un solo lugar.",
    journalText:
      "La Bitácora reúne respuestas, decisiones, evidencias, micro-misiones y registros personales para que puedas revisar tu avance.",
    connectionKicker: "05 · Conexión ZEDRO",
    connectionTitle:
      "Un espacio privado para ordenar, reflexionar y preparar tu oración.",
    connectionText:
      "Seleccionas lo que estás viviendo, exploras pasajes bíblicos relacionados, escribes una reflexión opcional y preparas una oración personal que puedes ajustar y conservar en tu Bitácora.",

    differenceLabel: "Qué hace diferente a ZEDRO Academy",
    differenceTitle:
      "No es contenido suelto. Es un proceso que conecta comprensión, decisión, acción y evidencia.",
    differenceLead:
      "ZEDRO Academy organiza cada recorrido para que la formación avance hacia una respuesta concreta y deje un registro útil del proceso.",
    diff1Title: "No es consumo pasivo",
    diff1Text:
      "Cada recorrido requiere reflexión, participación y aplicación; no se limita a ver o escuchar contenido.",
    diff2Title: "No depende solo de la inspiración",
    diff2Text:
      "La estructura, la repetición y la práctica ayudan a dar continuidad más allá del impulso del momento.",
    diff3Title: "No es contenido aislado",
    diff3Text:
      "Sistemas, días, micro-misiones y registros forman parte de una ruta intencional.",
    diff4Title: "Crece sobre una misma base",
    diff4Text:
      "La misma metodología permitirá incorporar progresivamente nuevas rutas de vida, liderazgo y gestión empresarial sin perder coherencia.",

    audienceLabel: "Para quién es",
    audienceTitle:
      "ZEDRO Academy es para personas que buscan una formación orientada por principios cristianos y aplicada a la vida real.",
    yesTitle: "Puede ser para ti si...",
    yesItems: [
      "Valoras una formación sobria y coherente, conectada con principios cristianos sin simplificaciones ni fórmulas prefabricadas.",
      "Quieres desarrollar criterio y relacionar principios con decisiones y acciones concretas.",
      "Estás dispuesto a participar con responsabilidad, práctica y constancia.",
    ],
    noTitle: "Puede no ser para ti si...",
    noItems: [
      "Buscas una solución rápida o resultados garantizados.",
      "Prefieres recibir contenido sin llevarlo a la práctica.",
      "No deseas asumir una participación activa en tu proceso.",
    ],

    ctaLabel: "Da el siguiente paso",
    ctaQuote: "Piensa con claridad. Decide con criterio. Construye con propósito.",
    ctaText:
      "Conoce los recorridos y herramientas actualmente disponibles en ZEDRO Academy, y comienza un proceso estructurado para llevar lo aprendido a la práctica.",
  },

  fr: {
    heroTitle:
      "Une méthodologie pour transformer la compréhension en décisions, en actions et en preuves concrètes.",
    heroSubtitle:
      "Chaque parcours de ZEDRO Academy combine formation, réflexion, micro-missions et suivi afin de vous aider à comprendre, ordonner, pratiquer et soutenir ce que vous apprenez dans la vie quotidienne.",
    viewMembership: "Commencez votre essai gratuit",
    seeHowItWorks: "Voir comment cela fonctionne",
    showcaseAria: "Aperçu de l’expérience ZEDRO",
    altMain: "Vue des systèmes de 28 jours dans ZEDRO Academy",
    altDay: "Vue d’une journée de formation dans ZEDRO Academy",
    altJournal: "Vue de la Bitácora ZEDRO",
    altMission: "Parcours d’une micro-mission quotidienne dans ZEDRO Academy",
    altConexion: "Vue de l’expérience guidée Connexion ZEDRO",

    problemLabel: "Le besoin auquel nous répondons",
    problemTitle:
      "Entre comprendre et avancer, il manque souvent une structure.",
    problemLead:
      "De nombreuses personnes accumulent informations, idées et inspiration, mais ont besoin d’un processus pour les transformer en décisions, en actions et en apprentissages durables.",
    problem1Title: "L’information ne s’organise pas toute seule.",
    problem1Text:
      "Vous pouvez connaître des principes précieux et avoir encore besoin de clarté pour les relier à vos priorités, à vos décisions et à votre vie quotidienne.",
    problem2Title: "L’intention a besoin d’un processus.",
    problem2Text:
      "Une structure claire aide à passer du désir d’avancer à une action définie, mise en pratique et ensuite évaluée.",
    problem3Title: "ZEDRO transforme la formation en parcours.",
    problem3Text:
      "La méthodologie relie compréhension, réflexion, action et suivi dans une progression cohérente.",

    methodLabel: "La méthode ZEDRO Academy",
    methodTitle: "Un cycle clair pour comprendre, ordonner, pratiquer et soutenir.",
    methodLead:
      "Chaque parcours travaille un domaine concret au moyen d’une séquence qui unit contenu, réflexion, pratique quotidienne et preuves du processus.",
    flowAria: "Cycle de formation ZEDRO",
    step1Title: "Comprendre",
    step1Text:
      "Vous recevez un contenu clair et des questions qui vous aident à examiner un domaine concret.",
    step2Title: "Ordonner",
    step2Text:
      "Vous reliez ce que vous apprenez à vos pensées, à vos priorités et à vos décisions.",
    step3Title: "Pratiquer",
    step3Text:
      "Vous le transformez en actions concrètes au moyen de micro-missions et d’une application quotidienne.",
    step4Title: "Soutenir",
    step4Text:
      "Vous consignez des preuves, révisez ce que vous apprenez et développez une continuité responsable.",
    methodStatementSmall: "Ce n’est pas une consommation passive.",
    methodStatementStrong:
      "C’est une formation appliquée avec structure, pratique et continuité.",

    insideLabel: "Disponible actuellement",
    insideTitle:
      "Voici comment fonctionne l’expérience offerte aujourd’hui dans ZEDRO Academy.",
    insideLead:
      "L’abonnement offre actuellement des systèmes de 28 jours, des journées guidées, des micro-missions, une Bitácora personnelle et Connexion afin de relier ce qui est appris à des décisions et à des pratiques concrètes.",
    systemKicker: "01 · Systèmes",
    systemTitle: "Des systèmes de 28 jours avec un parcours clair.",
    systemText:
      "Chaque système travaille un domaine concret pendant 28 jours, avec progression, continuité et une structure qui aide à avancer avec direction.",
    dayKicker: "02 · Journée ZEDRO Academy",
    dayTitle: "Une formation quotidienne pas à pas.",
    dayText:
      "Chaque journée organise contenu, réflexion, action, application et conclusion dans une séquence claire.",
    missionKicker: "03 · Micro-mission",
    missionTitle: "De petites actions qui laissent une trace du processus.",
    missionText:
      "La micro-mission transforme ce qui est appris en une action concrète et conserve une preuve du processus dans Bitácora ZEDRO.",
    journalKicker: "04 · Bitácora",
    journalTitle:
      "Décisions, actions et apprentissages réunis en un seul endroit.",
    journalText:
      "La Bitácora rassemble réponses, décisions, preuves, micro-missions et notes personnelles afin que vous puissiez revoir votre progression.",
    connectionKicker: "05 · Connexion ZEDRO",
    connectionTitle:
      "Un espace privé pour mettre de l’ordre, réfléchir et préparer votre prière.",
    connectionText:
      "Vous sélectionnez ce que vous vivez, explorez des passages bibliques connexes, rédigez une réflexion facultative et préparez une prière personnelle que vous pouvez ajuster et conserver dans votre Bitácora.",

    differenceLabel: "Ce qui rend ZEDRO Academy différent",
    differenceTitle:
      "Ce n’est pas du contenu isolé. C’est un processus qui relie compréhension, décision, action et preuves concrètes.",
    differenceLead:
      "ZEDRO Academy organise chaque parcours afin que la formation mène à une réponse concrète et laisse un suivi utile du processus.",
    diff1Title: "Ce n’est pas une consommation passive",
    diff1Text:
      "Chaque parcours demande réflexion, participation et application; il ne se limite pas à regarder ou à écouter du contenu.",
    diff2Title: "Cela ne dépend pas seulement de l’inspiration",
    diff2Text:
      "La structure, la répétition et la pratique aident à maintenir la continuité au-delà de l’élan du moment.",
    diff3Title: "Ce n’est pas du contenu isolé",
    diff3Text:
      "Systèmes, journées, micro-missions et suivis font partie d’un parcours intentionnel.",
    diff4Title: "La croissance repose sur une même base",
    diff4Text:
      "La même méthodologie permettra d’intégrer progressivement de nouveaux parcours de vie, de leadership et de gestion d’entreprise sans perdre en cohérence.",

    audienceLabel: "Pour qui",
    audienceTitle:
      "ZEDRO Academy s’adresse aux personnes qui recherchent une formation guidée par des principes chrétiens et appliquée à la vie réelle.",
    yesTitle: "Cette démarche peut vous convenir si...",
    yesItems: [
      "Vous valorisez une formation sobre et cohérente, ancrée dans des principes chrétiens, sans simplifications ni formules toutes faites.",
      "Vous souhaitez développer votre discernement et relier des principes à des décisions et à des actions concrètes.",
      "Vous êtes prêt à participer avec responsabilité, pratique et constance.",
    ],
    noTitle: "Cette démarche peut ne pas vous convenir si...",
    noItems: [
      "Vous cherchez une solution rapide ou des résultats garantis.",
      "Vous préférez recevoir du contenu sans le mettre en pratique.",
      "Vous ne souhaitez pas participer activement à votre processus.",
    ],

    ctaLabel: "Passez à l’étape suivante",
    ctaQuote:
      "Pensez avec clarté. Décidez avec discernement. Construisez avec intention.",
    ctaText:
      "Découvrez les parcours et les outils actuellement offerts par ZEDRO Academy, puis commencez un processus structuré pour mettre en pratique ce que vous apprenez.",
  },
};

function getInitialLanguage() {
  if (typeof window === "undefined") return "es";
  const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return savedLanguage === "fr" ? "fr" : "es";
}

export default function Metodologia() {
  const [language, setLanguage] = useState(getInitialLanguage);
  const t = copy[language] || copy.es;

  useEffect(() => {
    const syncLanguage = () => setLanguage(getInitialLanguage());

    window.addEventListener(LANGUAGE_CHANGE_EVENT, syncLanguage);
    window.addEventListener("storage", syncLanguage);

    return () => {
      window.removeEventListener(LANGUAGE_CHANGE_EVENT, syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);

  return (
    <main className="meth-page">
      <section className="meth-wrap" aria-labelledby="meth-title">
        <header className="meth-hero meth-hero--premium">
          <div className="meth-heroText">
            <h1 id="meth-title" className="meth-title">
              {t.heroTitle}
            </h1>

            <p className="meth-subtitle">{t.heroSubtitle}</p>

            <div className="meth-heroActions">
              <Link className="meth-btn meth-btnPrimary" to="/store">
                {t.viewMembership}
              </Link>

              <a className="meth-btn meth-btnGhost" href="#como-se-vive">
                {t.seeHowItWorks}
              </a>
            </div>
          </div>

          <div className="meth-heroShowcase" aria-label={t.showcaseAria}>
            <img
              className="meth-heroShot meth-heroShot--main"
              src="/assets/images/metodologia/metodologia-sistemas-vista-principal.png"
              alt={t.altMain}
            />

            <img
              className="meth-heroShot meth-heroShot--floating meth-heroShot--one"
              src="/assets/images/metodologia/metodologia-dia-momentos-verdad.png"
              alt={t.altDay}
            />

            <img
              className="meth-heroShot meth-heroShot--floating meth-heroShot--two"
              src="/assets/images/metodologia/metodologia-bitacora-recorrido.png"
              alt={t.altJournal}
            />
          </div>
        </header>

        <section className="meth-card">
          <section className="meth-section meth-section--problem meth-problemBlock">
            <div className="meth-problemIntro">
              <span className="meth-sectionLabel">{t.problemLabel}</span>

              <h2 className="meth-h2">{t.problemTitle}</h2>

              <p className="meth-lead">{t.problemLead}</p>
            </div>

            <div className="meth-problemGrid">
              <div className="meth-problemCard">
                <span>01</span>
                <h3>{t.problem1Title}</h3>
                <p>{t.problem1Text}</p>
              </div>

              <div className="meth-problemCard">
                <span>02</span>
                <h3>{t.problem2Title}</h3>
                <p>{t.problem2Text}</p>
              </div>

              <div className="meth-problemCard meth-problemCard--highlight">
                <span>03</span>
                <h3>{t.problem3Title}</h3>
                <p>{t.problem3Text}</p>
              </div>
            </div>
          </section>

          <section className="meth-section meth-methodBlock">
            <div className="meth-methodHeader">
              <span className="meth-sectionLabel">{t.methodLabel}</span>

              <h2 className="meth-h2">{t.methodTitle}</h2>

              <p className="meth-lead">{t.methodLead}</p>
            </div>

            <div className="meth-methodFlow" aria-label={t.flowAria}>
              <article className="meth-methodStep">
                <div className="meth-methodNum">01</div>
                <div className="meth-methodLine" />
                <h3>{t.step1Title}</h3>
                <p>{t.step1Text}</p>
              </article>

              <article className="meth-methodStep">
                <div className="meth-methodNum">02</div>
                <div className="meth-methodLine" />
                <h3>{t.step2Title}</h3>
                <p>{t.step2Text}</p>
              </article>

              <article className="meth-methodStep">
                <div className="meth-methodNum">03</div>
                <div className="meth-methodLine" />
                <h3>{t.step3Title}</h3>
                <p>{t.step3Text}</p>
              </article>

              <article className="meth-methodStep">
                <div className="meth-methodNum">04</div>
                <h3>{t.step4Title}</h3>
                <p>{t.step4Text}</p>
              </article>
            </div>

            <div className="meth-methodStatement">
              <span>{t.methodStatementSmall}</span>
              <strong>{t.methodStatementStrong}</strong>
            </div>
          </section>

          <section id="como-se-vive" className="meth-section meth-insideBlock">
            <div className="meth-insideHeader">
              <span className="meth-sectionLabel">{t.insideLabel}</span>

              <h2 className="meth-h2">{t.insideTitle}</h2>

              <p className="meth-lead">{t.insideLead}</p>
            </div>

            <div className="meth-showcaseList">
              <article className="meth-showcaseItem meth-showcaseItem--wide">
                <div className="meth-showcaseText">
                  <span className="meth-showcaseKicker">{t.systemKicker}</span>
                  <h3>{t.systemTitle}</h3>
                  <p>{t.systemText}</p>
                </div>

                <img
                  src="/assets/images/metodologia/metodologia-sistemas-vista-principal.png"
                  alt={t.altMain}
                />
              </article>

              <article className="meth-showcaseItem">
                <div className="meth-showcaseText">
                  <span className="meth-showcaseKicker">{t.dayKicker}</span>
                  <h3>{t.dayTitle}</h3>
                  <p>{t.dayText}</p>
                </div>

                <img
                  src="/assets/images/metodologia/metodologia-dia-momentos-verdad.png"
                  alt={t.altDay}
                />
              </article>

              <article className="meth-showcaseItem">
                <div className="meth-showcaseText">
                  <span className="meth-showcaseKicker">{t.missionKicker}</span>
                  <h3>{t.missionTitle}</h3>
                  <p>{t.missionText}</p>
                </div>

                <img
                  src="/assets/images/metodologia/metodologia-micro-mision-recorrido.png"
                  alt={t.altMission}
                />
              </article>

              <article className="meth-showcaseItem meth-showcaseItem--center">
                <div className="meth-showcaseText">
                  <span className="meth-showcaseKicker">{t.journalKicker}</span>
                  <h3>{t.journalTitle}</h3>
                  <p>{t.journalText}</p>
                </div>

                <img
                  src="/assets/images/metodologia/metodologia-bitacora-recorrido.png"
                  alt={t.altJournal}
                />
              </article>

              <article className="meth-showcaseItem meth-showcaseItem--wide">
                <div className="meth-showcaseText">
                  <span className="meth-showcaseKicker">
                    {t.connectionKicker}
                  </span>
                  <h3>{t.connectionTitle}</h3>
                  <p>{t.connectionText}</p>
                </div>

                <img
                  src="/assets/images/metodologia/metodologia-conexion-zedro.png"
                  alt={t.altConexion}
                />
              </article>
            </div>
          </section>

          <section className="meth-section meth-differenceBlock">
            <div className="meth-differenceHeader">
              <span className="meth-sectionLabel">{t.differenceLabel}</span>

              <h2 className="meth-h2">{t.differenceTitle}</h2>

              <p className="meth-lead">{t.differenceLead}</p>
            </div>

            <div className="meth-differenceGrid">
              <article className="meth-differenceCard">
                <span>{t.diff1Title}</span>
                <p>{t.diff1Text}</p>
              </article>

              <article className="meth-differenceCard">
                <span>{t.diff2Title}</span>
                <p>{t.diff2Text}</p>
              </article>

              <article className="meth-differenceCard">
                <span>{t.diff3Title}</span>
                <p>{t.diff3Text}</p>
              </article>

              <article className="meth-differenceCard meth-differenceCard--strong">
                <span>{t.diff4Title}</span>
                <p>{t.diff4Text}</p>
              </article>
            </div>
          </section>

          <section className="meth-section meth-audienceBlock">
            <div className="meth-audienceHeader">
              <span className="meth-sectionLabel">{t.audienceLabel}</span>

              <h2 className="meth-h2">{t.audienceTitle}</h2>
            </div>

            <div className="meth-cols">
              <div className="meth-col meth-col--yes">
                <h3>{t.yesTitle}</h3>
                <ul className="meth-list">
                  {t.yesItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>

              <div className="meth-col meth-col--no">
                <h3>{t.noTitle}</h3>
                <ul className="meth-list">
                  {t.noItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </section>

          <section className="meth-cta meth-ctaFinal">
            <span className="meth-sectionLabel">{t.ctaLabel}</span>

            <p className="meth-quote">{t.ctaQuote}</p>

            <p className="meth-ctaText">{t.ctaText}</p>

            <div className="meth-actions">
              <Link className="meth-btn meth-btnPrimary" to="/store">
                {t.viewMembership}
              </Link>
            </div>
          </section>
        </section>
      </section>
    </main>
  );
}
